import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { CARD_LABEL_HEIGHT, CARD_INFO_HEIGHT, CARD_FOOTER_HEIGHT } from 'config/cardConfig'
import { CardUtils } from 'utils'
import { Container as CardContainer } from 'components/cards/common/CardContainer/CardContainer.styled'
import { Title as CardTitle } from 'components/cards/common/CardTitle/CardTitle.styled'
import { UICardType } from 'components/cards/common/types'

export const Wrapper = styled.div`
  ${media.sm`
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    right: 0;
  `}
`

export const Preview = styled.div`
  display: none;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.small};
  `}

  ${({ theme }) => media.sm`
    display: block;
    margin-bottom: ${theme.space.desktop.small};
  `}
`

export const Label = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.tiny};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.small};
    height: ${CARD_LABEL_HEIGHT}px;
    min-height: ${CARD_LABEL_HEIGHT}px;
  `}
`

export const Title = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.tiny};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.tiny};
  `}
`

export const Info = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.tiny};
  `}

  ${media.sm`
    height: ${CARD_INFO_HEIGHT}px;
    min-height: ${CARD_INFO_HEIGHT}px;
    overflow: hidden;
  `}
`

export const Footer = styled.div`
  display: flex;
  align-items: center;

  ${media.sm`
    height: ${CARD_FOOTER_HEIGHT}px;
    min-height: ${CARD_FOOTER_HEIGHT}px;
  `}
`

export const Status = styled.div`
  flex-shrink: 0;

  ${({ theme }) => `
    margin-right: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    margin-right: ${theme.space.desktop.small};
  `}
`

export const Progress = styled.div`
  flex: 1 0;
`

type RootProps = {
  variant?: UICardType
  responsiveOnHover?: boolean
}

export const Root = styled.div<RootProps>`
  position: relative;
  z-index: 1;

  ${({ responsiveOnHover }) =>
    !responsiveOnHover &&
    `
      height: 100%;

      ${Wrapper}, ${CardContainer} {
        height: 100%;
      }
  `}

  ${({ variant }) => media.sm`
    height: ${CardUtils.getHeight(variant) || 'auto'};
  `}

  ${({ responsiveOnHover }) =>
    responsiveOnHover &&
    media.sm`
    &:hover {
      z-index: 3;

      ${Label}, ${Info}, ${Footer} {
        height: auto;
      }

      ${CardTitle} {
        height: auto;
        -webkit-line-clamp: unset;
      }
    }
  `}
`
